<template>
  <div class="propertyCreditScoreSystem">
    <div class="filters">
      <!-- 添加输入框和选择框、提交按钮 -->
      <el-form :inline="true">
        <el-form-item>
          <el-input
            class="seachInput"
            v-model="accountorname"
            :placeholder="$t('lang.pla_accountorname')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input class="seachInput" v-model="minscore" :placeholder="$t('lang.pla_minscore')"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input class="seachInput" v-model="maxscore" :placeholder="$t('lang.pla_maxscore')"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select
            class="select"
            v-model="orderpermission"
            :placeholder="$t('lang.PROPERTYCREDITSCORESYS.TYPE[0].label')"
          >
            <el-option
              v-for="item in orderpermissions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" @click="submit()">{{$t('lang.btn_search')}}</el-button>
      </el-form>
      <!-- 添加表格 -->
    </div>
    <el-card>
      <el-button type="primary" slot="header" @click="jump()">{{$t('lang.btn_look')}}</el-button>
      <el-table
        :data="tableData"
        class="wid100"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
      >
      <!-- checkbox选择框 -->
        <el-table-column
          type="selection"
          width="55"
          v-if="propertyCreditScoreSystemListcheckbox"
        ></el-table-column>
        <!-- 序号 -->
        <el-table-column
          type="index"
          :index="indexMethod" align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column>
        <!-- 姓名 -->
        <el-table-column prop="IdNo" :label="$t('lang.lab_name')"></el-table-column>
        <el-table-column prop="CreditScore" sortable :label="$t('lang.lab_creditInregral')"></el-table-column>
        <!-- 内容显示根据信用积分字段判断 -->
        <el-table-column :label="$t('lang.PROPERTYCREDITSCORESYS.TYPE[0].label')">
          <template slot-scope="scope">
            <span
              v-if="scope.row.CreditScore >60"
            >{{$t('lang.PROPERTYCREDITSCORESYS.TYPE[1].label')}}</span>
            <span v-else>{{$t('lang.PROPERTYCREDITSCORESYS.TYPE[2].label')}}</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 添加页码 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:communityManagement
 *@Description:物业信用积分体系
 *@author:李斌
 *@Copyright:格众科技
 *@date:2020-02-25
 */
import { mapGetters } from 'vuex'

export default {
  name:'/manage/main.creditScore',
  data() {
    // 表格内容默认数据
    return {
      tableData: [], // 表单数据
      multipleSelection: [], // 多选框
      orderpermissions: this.$i18n.t('lang.PROPERTYCREDITSCORESYS.TYPE'), // 下拉内容
      accountorname: '', // 账户或姓名
      minscore: '', // 最小积分
      maxscore: '', // 最大积分
      orderpermission: '0', // 操作
      pageCount: 0, // 总页数
      pageNum: 1, // 页数
      pageSize: 10, // 每页显示数量
      propertyCreditScoreSystemListcheckbox: require('@/config/enum')
        .propertyCreditScoreSystemListcheckbox // 是否隐藏复选框
    }
  },
  // 初始化
  created() {
    this.topics()
  },
  computed: {
      ...mapGetters(['gardenId'])
    },
  // 监听改变小区编号
  watch: {
    gardenId: function (newFlag, oldFlag) {
      this.topics()
    }
  },
  methods: {
    // ID序号功能
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    // 列表斑马线
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 进入页面后默认显示
    topics() {
      let loading = this.$loading()
      this.$get(
        `/creditScores?pageSize=${this.pageSize}&pageNo=${this.pageNum}&isReceipt=${this.orderpermission}&gardenId=${this.gardenId}&keyword=${this.accountorname}&minValue=${this.minscore}&maxValue=${this.maxscore}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 点击提交
    submit() {
      this.pageNum = 1
      this.topics()
    },
    // 跳转到详情页面
    jump() {
      this.$router.push({ name: 'propertyCreditScoreDetails' })
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNum = val
      this.topics()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.topics()
    }
  }
}
</script>

<style lang= 'scss' scoped>

</style>